export enum NombresProductoEnum {
    ARRIENDO_LITE_POS = 'Pocket POS',
    ARRIENDO_MPOS = 'Mobile POS (mPOS)',
    ARRIENDO_PACK_CELULAR = 'Pack POS',
    ARRIENDO_PACK_INTERNET = 'Pack POS',
    ARRIENDO_POS_FIJO_CELULAR = 'Máquina POS',
    ARRIENDO_POS_FIJO_INTERNET = 'Máquina POS',
    ARRIENDO_POS_MOVIL = 'Smart POS',
    ARRIENDO_POS_MOVIL_20DIAS = 'POS temporal',
    ARRIENDO_POS_MOVIL_90DIAS = 'POS temporal',
    ARRIENDO_POS_MOVIL_FERIA = 'Máquina POS feria o evento',
    ARRIENDO_SMARTPOS = 'Smart POS',
    BASE = 'base',
    COBRA_CON_LINK_PAGO = 'Link de pago Webpay.cl',
    COBRO_QR = 'Cobro QR',
    CREA_TU_SITIO_WEB_CON_PST = 'Crea tu sitio web con expertos',
    CREA_TU_SITIO_WEB_CON_WIX = 'Crea tu sitio web con alianza WIX',
    CREACION_SITIO_ALIANZA_WIX = 'Crea tu sitio web con alianza WIX',
    CREACION_SITIO_PST = 'Crea tu sitio web con expertos',
    INTEGRA_MEDIO_PAGO_CON_TRANSBANK = 'WebPay - Integración Transbank',
    INTEGRA_MEDIO_PAGO_POR_TU_CUENTA = 'WebPay - Integración por mi cuenta',
    INTEGRADOR_CLIENTE = 'WebPay - Integración por mi cuenta',
    INTEGRADOR_TRANSBANK = 'WebPay - Integración Transbank',
    LINK_PAGO = 'Link de pago Webpay.cl',
    PACK_POS_MOVIL_LP="Pack Arriendo POS Móvil + link de pago",
    PACK_VENTA_MPOS_LP = 'Pack MPOS venta + Webpay.cl',
    PACK_VENTA_MPOS_LP_GARANTIA = 'Pack MPOS venta + Webpay.cl + Garantía',
    VENTA_MPOS = 'Nuevo Mobile POS',
    VENTA_MPOS_GARANTIA = 'Nuevo Mobile POS + garantía'
}
